/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 as Typography } from '@coursera/cds-core';

import Container from 'bundles/premium-hub/components/shared/Container';
import type { CareerRolesModuleData } from 'bundles/premium-hub/types';

type Props = {
  moduleData?: CareerRolesModuleData | null;
};

const styles = {
  moduleContainer: css`
    margin-top: var(--cds-spacing-400);
  `,
};

const CareerRolesModule = ({ moduleData }: Props) => {
  if (!moduleData) return null;

  return (
    <Container css={styles.moduleContainer}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="subtitleLarge" component="h2">
            {moduleData.title}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CareerRolesModule;
